<template>
  <div class="product-codes-transfer-container">
    <i-transfer
      :titles="['可选型号', '选中型号']"
      :operations="['删除', '添加']"
      :data="productCodes"
      :targetKeys="selectProductCodes"
      :render-format="renderFormat"
      @on-change="handleChange1"></i-transfer>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ProductCodesTransfer',
  props: {
    productCodes: { type: Array, required: true },
  },
  computed: {
    selectProductCodes() {
      return this.$store.state.createPaperStore.addBigQuestionRule.productCodes;
    },
  },
  methods: {
    ...mapActions({
      setAddBigQuestionRuleOfProductCodes: 'createPaperStore/invokeSetAddBigQuestionRuleOfProductCodes',
    }),
    renderFormat(item) {
      return item.shortName;
    },
    handleChange1(newTargetKeys) {
      this.setAddBigQuestionRuleOfProductCodes({ productCodes: newTargetKeys });
    },
  },
};
</script>

<style lang="less" scoped>
.product-codes-transfer-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  padding: 20px;
  border-radius: 4px;

  /deep/ .ivu-transfer-list-header {
    background-color: #2d8cf0;
    color: #fff;
  }
}
</style>
